import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Navigate, Route, Routes } from 'react-router-dom';
import CreateProjectReport from './CreateProjectReport';
import ProjectCompletion from './ProjectCompletion';
import ProjectCompletionReport from './ProjectCompletionReport';
import ProjectInProgress from './ProjectInProgress';
import ProjectInProgressTicket from './ProjectInProgressTicket';
import ProjectNav from './ProjectNav';
import ProjectProposal from './ProjectProposal';

const ProjectLayout = () => {
  return (
    <div className="py-0">
      <Row className="g-3">
        <Col md={3}>
          <ProjectNav />
        </Col>
        <Col md={9}>
          <Routes>
            <Route path="project_in_progress" element={<ProjectInProgress />} />
            <Route path="project_proposal" element={<ProjectProposal />} />
            <Route
              path="project_in_progress/:project_id"
              element={<ProjectInProgressTicket />}
            />
            <Route
              path="project_in_progress/create_report"
              element={<CreateProjectReport />}
            />
            <Route path="complete_project" element={<ProjectCompletion />} />
            <Route
              path="complete_project/report"
              element={<ProjectCompletionReport />}
            />
            <Route
              path="*"
              element={<Navigate to="project_in_progress" replace />}
            />
          </Routes>
        </Col>
      </Row>
    </div>
  );
};

export default ProjectLayout;
